import { clsx } from "clsx";
import { extendTailwindMerge } from "tailwind-merge";

// tailwind-merge non conosce le misure del tema: senza questa estensione scambia text-caption, text-h1…
// per colori e li cancella quando nella stessa classe c'è anche text-ink-2.
const twMerge = extendTailwindMerge({
  extend: {
    theme: {
      text: ["hero", "display", "h1", "h1-mobile", "h2", "h3", "card-title", "h4", "label", "body", "body-strong", "small", "caption", "micro", "eyebrow"],
      shadow: ["segment", "overlay"],
      ease: ["enter", "exit"],
      animate: ["ida-rise", "ida-sheet", "ida-panel", "ida-fade", "ida-exit", "ida-skeleton"],
      radius: ["xs", "sm", "md", "lg", "xl"],
    },
  },
});

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}
